
<template>
    <div>
        <Drawer :closable="false" placement="right" v-model="drawerVisible" width="50%" :title="drawerTitle"
                destroy-on-close="true">
            <Row>
                <Col>
                    <Card :shadow="false">
                        <Row>
                            <Form ref="form" :model="form" :label-width="100" style="position:relative"
                                  :rules="formValidate">
                                <FormItem label="模块标题" prop="title">
                                    <Input v-model="form.title" style="width:600px"/>
                                </FormItem>
                                <FormItem label="排序位置" prop="sortOrder">
                                    <InputNumber v-model="form.sortOrder" style="width:600px"/>
                                </FormItem>
                                <FormItem label="模块分类">
                                    <el-select v-model="form.type">
                                        <el-option disabled label="请选择分类" :value="0"></el-option>
                                        <el-option label="新闻栏目" :value="1"></el-option>
                                        <el-option label="学习/考试" :value="2"></el-option>
                                        <el-option label="评价/认定" :value="3"></el-option>
                                        <el-option label="首页标题" :value="4"></el-option>
                                        <el-option label="个人中心背景" :value="5"></el-option>
                                    </el-select>
                                </FormItem>
                                <FormItem label="是否超链接">
                                    <i-switch
                                        size="large"
                                        v-model="form.linkYes"
                                        :true-value="1"
                                        :false-value="0"
                                    >
                                        <span slot="open">是</span>
                                        <span slot="close">否</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem label="页面路径"  v-if="form.linkYes==1">
                                    <Input :disabled = "true" v-model="form.path" style="width:600px"/>
                                </FormItem>
                                <FormItem label="图片" v-if="form.linkYes==1 || form.type==5">
                                    <el-upload
                                        accept="image/*"
                                        class="avatar-uploader"
                                        action="#"
                                        :http-request="uploadImg"
                                        :show-file-list="false"
                                        :on-change="handleChange"
                                        v-model="form.imgUrl"
                                    >
                                        <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                                    </el-upload>
                                    <Button v-if="form.imgUrl != '' " @click="showPic(form.imgUrl)" >查看大图</Button>
                                    <el-dialog width="30%" :visible.sync="dialogVisible">
                                        <img v-if="form.imgUrl != ''" width="" :src="form.imgUrl" alt/>
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-dialog>
                                </FormItem>
                                <Modal  v-model="picVisible" title="图片" draggable style="width: 1000px;" >
                                    <Scroll>
                                        <img  :src="img" alt="无效的图片链接" style="width: 100%; ">
                                    </Scroll>
                                </Modal>
                                <Form-item class="br" v-if="!disabledSingle">
                                    <Button type="primary" :loading="submitLoading" @click="handelSubmit"
                                            style="width:80px">提交
                                    </Button>
                                    <Button @click="handelCancel">取消</Button>
                                </Form-item>

                                <Spin size="large" fix v-if="loading"></Spin>
                            </Form>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Drawer>
    </div>
</template>
<script>
import {addText,selectCourseType} from "@/api/bus";
import treeSelect from "@/component/tree/treeSelect.vue";
export default {
    name: "xcxtext-drawer",
    components: {
        treeSelect
    },
    data() {
        return {
            drawerTitle: "编辑模块信息",
            form: {
                title: '',
                sortOrder: 0,
                type: 0,
                linkYes: 0,
                courseList: [],
                imgUrl: '',
                path: '',
            },
            picVisible: false,
            img: '',
            dialogVisible: false,
            courseTypes: [],
            drawerVisible: false,
            submitLoading: false, // 添加或编辑提交状态
            loading: false, // 表单加载状态
            disabledSingle: false,
            formValidate: {
                title: [{required: true, message: "模块名称不能为空", trigger: "blur"}],
                sortOrder: [{required: true, type: 'number', message: "排序不能为空", trigger: "blur"}],

            }
        };

    },
    methods: {
        showDrawer(params) {
            if (params) {
                this.drawerTitle = "编辑模块信息"
                // this.getXcxDetail(params.id);
                this.form.id = params.id
                this.form.title = params.title
                this.form.type = params.type
                this.form.sortOrder = params.sortOrder
                this.form.linkYes = params.linkYes
                this.form.imgUrl = params.imgUrl
                this.form.path = params.path

            } else {
                this.drawerTitle = "新增模块信息"
                this.cleanForm()
            }
            this.drawerVisible = true;
        },
        cleanForm() {
            this.form.id = ''
            this.form.title = ''
            this.form.type = 0
            this.form.sortOrder = 0
            this.form.linkYes = 0
            this.form.imgUrl = ''
            this.form.path = ''
        },
        handelSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.form.type == 0) {
                        return this.$Message.error("请选择分类");
                    }
                    addText(this.form).then(res => {
                        this.submitLoading = false;
                        if (res.status) {
                            this.$Message.success("操作成功");
                            this.$parent.getDataList();
                            this.drawerVisible = false;
                        }
                    });


                }
            });
        },
        handelCancel() {
            this.drawerVisible = false;
            this.cleanForm();
        },
        uploadImg({file}) {
            console.log("上传", file);
            this.$oss
                .put("/xcx/image/" + file.uid + file.name, file)
                .then((data) => {
                    console.log(data);
                    this.form.imgUrl = data.url;
                });
        },

        handleChange(file, fileList) {
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }  // 每次上传显示的都是当前的，只能有一个（不用limit来限制了）
            // 格式无误后，预览文件处理
            this.imgSaveToUrl(file)
            // 复刻文件信息
            this.fileList = file.raw

        },
        imgSaveToUrl(file) {
            // 获取上传图片的本地URL，用于上传前的本地预览，转换后的地址为 blob:http://xxx/7bf54338-74bb-47b9-9a7f-7a7093c716b5
            this.form.imgUrl = URL.createObjectURL(file.raw)
        },
        getCrouseList() {
            selectCourseType({parentId: 0}).then((data) => {
                this.courseTypes = data.data;
            });
            console.log("【课程】", this.courseTypes);
        },
        courseTypeEvent(eventDetail, treeData) {
            console.log("examTypeEvent", eventDetail, treeData);
            switch (eventDetail.type) {
                case "chosenKeysConfirm":
                    this.form.courseList = eventDetail.chosenKeys;
                    break;
                case "chosen":
                    console.log(eventDetail);
                    this.form.value = eventDetail.value;
                    break;
                case "select":
                    this.temporaryTree = eventDetail.value;
                    break;
                case "confirm":
                    this.form.courseList = this.temporaryTree.id;
                    break;
                default:
                    break;
            }
        },

        showPic(v) {
            this.img = v;
            this.picVisible = true;
        },
    },



    mounted() {
        this.getCrouseList();
    },
    watch: {
    },


    };
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 150px;
    height: 200px;
    display: block;
}



</style>